import axios from "axios";
import { services } from "configs/api";
import { dataTransferServiceFor } from "configs/products";

const Organizations = {
  all(product, env) {
    return axios.get(
      services.productService(
        product,
        dataTransferServiceFor(env),
        `organizations/${product}/${env}`
      )
    );
  },
  get(env, subdomain) {
    return axios.get(
      services.enroll(env, `core/v1/internal/organizations/${subdomain}`)
    );
  },
  create(payload) {
    const env = payload["environment"];
    return axios.post(
      services.enroll(env, "core/v1/internal/organizations"),
      payload
    );
  },
};

export default Organizations;
